import { useState, type FormEvent } from 'react';
import { ApiError } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { Button, Field } from '../ui/kit';
import { HotelLogo } from '../ui/HotelLogo';

export function Login() {
  const { login, state } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const notice = state.status === 'anon' ? state.notice : undefined;

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="card login-card" onSubmit={submit} noValidate>
        <HotelLogo className="logo" alt="AA CountrySide Hotel" />
        <div>
          <h1 className="h1">Staff sign in</h1>
          <p className="muted">AA CountrySide Hotel · Paga</p>
        </div>
        {notice ? (
          <div className="banner info" role="status">
            {notice}
          </div>
        ) : null}
        {error ? (
          <div className="banner bad" role="alert">
            {error}
          </div>
        ) : null}
        <Field id="email" label="Email">
          <input id="email" className="input" type="email" autoComplete="username" inputMode="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </Field>
        <Field id="password" label="Password">
          <input id="password" className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </Field>
        <Button variant="primary" block loading={busy} type="submit" disabled={!email || !password}>
          Sign in
        </Button>
      </form>
    </div>
  );
}
